import { render, staticRenderFns } from "./textarea_nolang.vue?vue&type=template&id=594d59ff"
import script from "./textarea_nolang.vue?vue&type=script&lang=js"
export * from "./textarea_nolang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports